export const setWidgetInScroll = (state, widgetInScroll) => {
  return { widgetInScroll };
};
